import { makeStyles, tokens } from "@fluentui/react-components";
export const useLinkToExistingPlanDialogStyles = makeStyles({
    dialogSurface: {
        width: "calc(100vw - 32px)",
        maxWidth: "600px",
        backgroundColor: tokens.colorNeutralBackground1,
        color: tokens.colorNeutralForeground1
    },
    dialogTitle: {
        fontWeight: tokens.fontWeightSemibold,
        padding: "0px"
    },
    dialogContent: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalL,
        paddingTop: tokens.spacingVerticalS,
        paddingBottom: tokens.spacingVerticalL
    },
    description: {
        color: tokens.colorNeutralForeground1
    },
    // Matches the Move Task dialog's plan picker: a filled background box (no border) that
    // distinguishes the control from the dialog surface when unselected.
    planControlContainer: {
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusXLarge,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    button: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: "auto"
    }
});
